import { useCallback, useContext } from "react"
import { TicketContext } from "../TicketContext"
import { ReactComponent as GoIcon } from 'assets/icons/Go.svg';
import { SvgIcon } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { sendMessageFetch, updateMessageFetch } from "store/middlewares/tickets.crud";
import { useParams } from "react-router-dom";
import { queryClient as qc } from 'keys'
import { toast } from "react-toastify";
import { toastConfig } from "config";

const useCreateTicketMessageBtn = () => {
    const params = useParams()
    const queryClient = useQueryClient()
    const { setMessageId, messageId, setMessage, message, image, setImage } = useContext(TicketContext)

    const { mutateAsync: postMessage, isPending } = useMutation({
        mutationFn: sendMessageFetch,
        onSuccess: () => {
            queryClient.invalidateQueries([qc.ticketMessages])
            queryClient.invalidateQueries([qc.ticket])
            queryClient.invalidateQueries([qc.newTicketCount])
        }
    })

    const { mutateAsync: updateMessage, isPendings } = useMutation({
        mutationFn: updateMessageFetch,
        onSuccess: () => {
            queryClient.invalidateQueries([qc.ticketMessages])
            queryClient.invalidateQueries([qc.ticket])
            queryClient.invalidateQueries([qc.newTicketCount])
        }
    })

    const sendMessage = useCallback(() => {
        if (!message) {
            toast.error("אנא הכנס תוכן להודעה", toastConfig)
            return
        }
        let messageData = {
            content: message,
            image: image,
        }
        if (messageId)
            updateMessage({ id: messageId, values: messageData })

        else {
            messageData.ticket = params.ticketID
            postMessage(messageData)
        }
        setMessage('')
        setMessageId(null)
        setImage(null)
    }, [message, image, messageId])

    const createTicketMessageBtn = {
        label: messageId ? "עדכון" : "שליחה",
        action: sendMessage,
        color: "secondary",
        size: "small",
        icon: <SvgIcon component={GoIcon} inheritViewBox />,
        direction: "rtl",
        loading: isPending,
        disabled: isPending
    }

    return createTicketMessageBtn
}

export default useCreateTicketMessageBtn